
// npm
import * as Immutable from 'immutable'

// custom
import {getProp} from 'custom/object-helper'

// redux
import {extractMessage} from 'redux/reducers/exam/helpers'
import {SET_EXAM_DATA} from 'redux/reducers/exam/action-types'


const OPTION_REDUCER = (state=Immutable.Map(), action) =>
{
	switch (action.type)
	{
		case SET_EXAM_DATA:
			state = state.set('id', action.data['@ID']);
			const optionText = extractMessage(getProp(action, 'data.TEXT'));
			state = state.set('text', optionText);
			return state.set('selected', getProp(action, 'data.@Selected'));
		default:
			return state;
	}
}


export {OPTION_REDUCER}